<template>
    <div class="cert-actions">
        <button
            v-if="issued"
            type="button"
            class="cert-actions__primary"
            @click="$emit('view')"
        >
            <v-icon size="18" aria-hidden="true">mdi-eye-outline</v-icon>
            {{ $t('student.certificates.viewCertificate') }}
        </button>
        <button
            v-else-if="eligible"
            type="button"
            class="cert-actions__primary"
            :disabled="issuing"
            :aria-busy="issuing"
            @click="$emit('generate')"
        >
            <v-icon size="18" aria-hidden="true">mdi-certificate</v-icon>
            {{ $t('student.certificates.generateCertificate') }}
        </button>
        <button
            v-else-if="courseId != null && courseId !== ''"
            type="button"
            class="cert-actions__primary"
            @click="$emit('continue')"
        >
            <v-icon size="18" aria-hidden="true">mdi-play</v-icon>
            {{ $t('student.certificates.continueCourse') }}
        </button>

    </div>
</template>

<script>
    export default {
        name: 'CertificateActions',
        props: {
            issued: { type: Boolean, default: false },
            eligible: { type: Boolean, default: false },
            courseId: { type: [String, Number], default: null },
            issuing: { type: Boolean, default: false },
        },
        emits: ['view', 'generate', 'continue'],
    };
</script>

<style scoped>
    .cert-actions {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        gap: 8px;
    }

    .cert-actions button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        height: 36px;
        min-height: 36px;
        padding: 0 12px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 0.82rem;
        cursor: pointer;
        white-space: nowrap;
    }

    .cert-actions button:focus-visible {
        outline: 2px solid var(--certs-accent, #1ac4cd);
        outline-offset: 2px;
    }

    .cert-actions__primary {
        border: 0;
        background: #1ac4cd;
        color: #fff;
    }

    .cert-actions__primary :deep(.v-icon) {
        color: #fff;
    }

    .cert-actions__primary:disabled {
        opacity: 0.65;
        cursor: wait;
    }

    @media (max-width: 860px) {
        .cert-actions {
            flex-direction: column;
        }

        .cert-actions button {
            width: 100%;
        }
    }
</style>
